import { useContext } from 'react';

import { UserContext } from './AuthUserContext';

export function useOnLogout() {
  const userInfo = useContext(UserContext);

  if (userInfo) {
    return userInfo.onLogout;
  }

  throw new Error('useOnLogout must be used inside UserContext Provider. User information not found.');
}
